import React from 'react';
import { getCarIcon } from 'entities/cars/utils';
import { CarAvatar } from 'shared/components';
import { useGetActiveStatus } from 'entities/cars/hooks';

interface AutoIconProps {
  autoNumber?: Nullable<string>;
  vehicleWeightUnladen?: number;
}

export const AutoIcon = ({ autoNumber, vehicleWeightUnladen }: AutoIconProps) => {
  const getActiveStatus = useGetActiveStatus();
  return <CarAvatar kind={getCarIcon(vehicleWeightUnladen)} activeStatus={getActiveStatus(autoNumber)} />;
};
